import { Box, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import PunchOutSupplier from "./punchOutSupplier";

const PunchOutSuppliers = () => {
    // Collect states and state dispatchers
    const suppliersColl = useSelector((state) => state.punchOut);
    const suppliers = suppliersColl.punchOutSuppliers;

    return (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
            <Grid container spacing={2}>
                {suppliers.map((supplier) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={supplier.supplierName}
                    >
                        <PunchOutSupplier supplier={supplier} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default PunchOutSuppliers;
